import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {Box, Grid, IconButton, Typography} from '@mui/material';

import {LanguageContext} from '../../../../../../../../../contexts/LanguageContext/LanguageContext';
import {ALL_LANGUAGES_LIST} from '../../../../../../../../../lib/languagesListConst';
import {LanguageSkill} from '../../../../../types/JobPostingsTypes';

interface HardFactsFieldsLanguageSkillsListProps {
  languageSkills: Partial<LanguageSkill>[];
  onRemove(index: number): void;
  onEdit(languageSkill: Partial<LanguageSkill>): void;
}

export const HardFactsFieldsLanguageSkillsList = ({
  languageSkills,
  onRemove,
  onEdit,
}: HardFactsFieldsLanguageSkillsListProps) => {
  const {t} = useTranslation();
  const currentSystemLanguage = useContext(LanguageContext);

  const getLanguageLabel = (language: string) => {
    const languageLabel = ALL_LANGUAGES_LIST.find((lang) => lang.id === language);
    return languageLabel ? languageLabel.label[currentSystemLanguage] : '';
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.light',
        p: 2,
        m: 2,
        maxHeight: '300px',
        overflow: 'auto',
      }}
    >
      <Typography variant='h4' mb={2}>
        {t('companyJobPostings.newJobDialog.formPlaceholders.currentLanguageSkills')}
      </Typography>
      <Grid container>
        {[...languageSkills].reverse().map((languageSkill) => (
          <Grid
            item
            xs={12}
            sm={12}
            key={languageSkill.language}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <Typography variant='body1'>
                - {languageSkill.language ? getLanguageLabel(languageSkill.language) : ''} {languageSkill.level}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              key={languageSkill.language}
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <IconButton
                name='deleteLanguageSkill'
                onClick={() => {
                  onRemove(languageSkills.indexOf(languageSkill));
                }}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                name='editLanguageSkill'
                onClick={() => {
                  onEdit(languageSkill);
                }}
              >
                <EditIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
